import React, { useContext, useEffect, useState } from "react";
import LoginPage from "./LoginPage/LoginPage.js";
import { useNavigate } from "react-router-dom";
import { Context } from "../../utils/context.js";
import { SplashScreen } from "../animation/Animation.js";

const Login = () => {
  const { signin, usertype } = useContext(Context);
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(true);

  let redirectTo = null;
  if (signin) {
    if (usertype === "demo") redirectTo = "/demo";
    else if (usertype?.length) redirectTo = "/advanceDashboard";
  }

  useEffect(() => {
    if (redirectTo) navigate(redirectTo);
  }, [redirectTo, navigate]);

  if (redirectTo) return null;

  return (
    <>
      {showSplash && (
        <SplashScreen
          logo="/assets/images/Vasro_Ventures.png"
          onFinish={() => setShowSplash(false)}
        />
      )}
      <LoginPage />
    </>
  );
};

export default Login;
